module.exports = __webpack_public_path__ + "fonts/firacode-regular.0b673e9.woff";